import Vue from 'vue';
import Store from '@/store';
import { getUrlParam } from '@/utils';
import { isLalamove } from '@/components/templates/helper';

export const API_NAME = {
  getPageInfo: '/web/template/getPageInfo',
  doTask: '/web/template/doTask',
  queryRewardType: '/web/reward/queryType',
  getAwards: '/web/reward/query',
  withdraw: '/web/reward/takeCash',
  address: '/web/reward/queryGoodsAddress',
  getShareCode: '/web/invitation/shareCode',
  reportInvited: '/web/invitation/addInvitee',
  saveAddress: '/web/reward/addGoodsAddress'
};
const getCommonData = () => {
  return {
    locationInfo: Store.state.app && Store.state.app.locationObj
  };
};

const commonQueryParams = {
  hlang: getUrlParam('hlang') || undefined,
  hcountry: getUrlParam('hcountry') || undefined
};

// 奖励页接口固定的 label 参数，用于区分其他活动
const getAwardCommonLabel = () => {
  if (Store.state.global && isLalamove(Store.state.global.businessLine)) {
    return {
      label: 'INTERNATIONALIZATION_DRAW'
    };
  }
  return {
    label: 'COMMON_TEMPLATE_ACTIVITY'
  };
};

const doBasePost = (api, data = {}) => {
  return Vue.prototype.$request.post(
    api,
    {
      ...getCommonData(),
      ...data
    },
    {
      params: commonQueryParams
    }
  );
};

export const getPageInfo = code => {
  return doBasePost(API_NAME.getPageInfo, {
    code
  });
};

export const submitDraw = data => {
  return doBasePost(API_NAME.doTask, data);
};

export const doTask = data => {
  return doBasePost(API_NAME.doTask, data);
};

export const queryRewardType = () => {
  return doBasePost(API_NAME.queryRewardType, getAwardCommonLabel());
};

export const getMyAwards = (data = {}) => {
  return doBasePost(API_NAME.getAwards, {
    ...data,
    ...getAwardCommonLabel(),
    code: Store.state.global.actName
  });
};

export const submitWithdraw = data => {
  return doBasePost(API_NAME.withdraw, {
    ...data,
    ...getAwardCommonLabel()
  });
};

export const getUserAddress = () => {
  return doBasePost(API_NAME.address);
};

export const submitAddress = data => {
  return doBasePost(API_NAME.saveAddress, data);
};

export const fetchShareCode = data => {
  return doBasePost(API_NAME.getShareCode, data);
};

export const reportInvited = data => {
  return doBasePost(API_NAME.reportInvited, data);
};
